import { useNavigate } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";

export default function HeroSection() {
  const { t } = useLang();
  const { openAuthModal, user } = useAuth();
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20earth%20globe%20from%20outer%20space%20with%20golden%20glowing%20grid%20lines%20overlaid%20on%20continents%2C%20deep%20space%20background%20with%20stars%2C%20ultra%20cinematic%2C%208k%2C%20dramatic%20lighting%2C%20abstract%20futuristic%20world%20map%2C%20black%20and%20dark%20navy%20tones%20with%20amber%20gold%20accents&width=1440&height=900&seq=hero1&orientation=landscape"
          alt="World globe background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-[#0a0a0f]"></div>
        {/* Grid overlay effect */}
        <div
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,200,50,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,200,50,0.3) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 w-full max-w-5xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-amber-400/10 border border-amber-400/30 rounded-full px-5 py-2 mb-8">
          <div className="w-2 h-2 bg-amber-400 rounded-full animate-pulse"></div>
          <span className="text-amber-400 text-sm font-medium whitespace-nowrap">
            {" "}
            {" "}
            1ブロック = 100㎡ = 100 coins
          </span>
        </div>

        <h1
          className="text-6xl md:text-8xl lg:text-9xl font-black text-white mb-6 leading-none font-['Space_Grotesk',sans-serif]"
          style={{
            textShadow: "0 0 80px rgba(251,191,36,0.3)",
          }}
        >
          <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-orange-500 bg-clip-text text-transparent">
            世界を
          </span>
          <br />
          <span className="text-white">買えろ</span>
        </h1>

        <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          {t("heroSubtitle")}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate("/map")}
            className="group flex items-center gap-3 bg-gradient-to-r from-amber-400 to-orange-500 hover:from-amber-300 hover:to-orange-400 text-black font-bold text-lg rounded-full px-10 py-4 transition-all shadow-2xl shadow-amber-500/30 cursor-pointer whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-map-2-line text-lg"></i>
            </div>
            {t("heroBtn")}
            <div className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </button>
          {!user && (
            <button
              onClick={() => openAuthModal("register")}
              className="flex items-center gap-2 border border-white/30 hover:border-amber-400/50 text-white hover:text-amber-400 font-medium text-lg rounded-full px-10 py-4 transition-all cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-user-add-line text-lg"></i>
              </div>
              {t("navRegister")}
            </button>
          )}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-gray-500 text-xs whitespace-nowrap">Scroll</span>
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-arrow-down-line text-gray-500 text-sm"></i>
        </div>
      </div>
    </section>
  );
}
